const galleriesListsSelector = ({ adminState: { adminGalleriesListState } }) => adminGalleriesListState.galleriesLists
const currentGalleriesListSelector = ({ adminState: { adminGalleriesListState } }) => adminGalleriesListState.currentGalleriesList

export {
    galleriesListsSelector,
    currentGalleriesListSelector,
}
